export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v1/assets/circle_open-be33780fea29463a9a9d71c699d974dd.svg";